export function useDrawerBodyLock(open: Ref<boolean>) {
  const isLocked = useScrollLock(import.meta.client ? document.body : null)

  watchEffect(() => {
    isLocked.value = open.value
  })
}
